import React, { useState, useCallback } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

const Organization = ({ state }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(true);

  const handleExpansionChange = useCallback(() => {
    setExpanded(expanded => !expanded);
  }, []);

  const sortOrder = [
    { label: t('layouts.ascending'), value: 'Ascending' },
    { label: t('layouts.descending'), value: 'Descending' },
  ];

  return (
    <StyledRootAccordion expanded={expanded} onChange={handleExpansionChange}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography className="heading">{t('layouts.organization')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="h5" className="subheading">
          {t('layouts.sorting')}
        </Typography>
        <Box display="flex" flexDirection="column" alignItems="start" pt={1}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="tile-columns">{t('layouts.sortBy')}</InputLabel>
            <Select
              fullWidth
              label={t('layouts.sortBy')}
              name="sortBy"
              value={state.sortBy}
              onChange={state.handleChange}
            >
              {[
                {
                  label: t('layouts.beverageName'),
                  value: '_name',
                },
                {
                  label: t('layouts.beverageType'),
                  value: '_type',
                },
                {
                  label: t('layouts.tapNumber'),
                  value: 'sort_value',
                },
              ].map((val, i) => {
                if (i === 2 && state.lists.some(({ method }) => method === 3)) return null;
                return (
                  <MenuItem key={val.value} value={val.value}>
                    <span className="option">{val.label}</span>
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="tile-columns">{t('layouts.sortOrder')}</InputLabel>
            <Select
              fullWidth
              label={t('layouts.sortOrder')}
              name="sortOrder"
              value={state.sortOrder}
              onChange={state.handleChange}
            >
              {sortOrder.map(item => (
                <MenuItem key={item.value} value={item.value.toLowerCase()}>
                  <span className="option">{item.label}</span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Typography variant="h5" className="subheading">
          {t('layouts.menuGroups')}
        </Typography>
        <Box display="flex" flexDirection="column" alignItems="start" pt={1}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="tile-columns">{t('layouts.groupBy')}</InputLabel>
            <Select
              fullWidth
              label={t('layouts.groupBy')}
              name="groupBy"
              value={state.groupBy}
              onChange={state.handleChange}
            >
              {['N/A', t('layouts.category'), t('layouts.type')].map(val => (
                <MenuItem key={val} value={val.toLowerCase()}>
                  <span className="option">{val}</span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </AccordionDetails>
      <Divider />
    </StyledRootAccordion>
  );
};

export default observer(Organization);

const StyledRootAccordion = styled(Accordion)(({ theme }) => ({
  '.heading': {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: theme.typography.fontWeightRegular,
    '& > .MuiIconButton-edgeEnd': {
      marginRight: '0 !important',
    },
  },
  '.subheading': {
    textDecoration: 'underline',
    marginBottom: theme.spacing(1),
  },
}));
